import axios from "axios";
import * as base64 from "@/utils/base64Encode.js";
import { ElMessage, ElMessageBox } from 'element-plus'
const url = window.serverUrl || window.location.protocol + "//" + window.location.host;
let BASE_URL = process.env.VUE_APP_API_URL || "";
// 创建 axios 实例
const service = axios.create({
  baseURL: BASE_URL || url,
  timeout: 50000,
  headers: {
    "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
    Authorization: "Basic " + window.btoa("webApp:webApp"),
  },
  withCredentials: true,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    config.url = BASE_URL + config.url;
    let url = window.location.hash;
    let hashUrl = url.slice(1).split("?");
    let hashUrl2 = hashUrl[0];
    config.headers["page-Url"] = hashUrl2;
    // if (sessionStorage.getItem("token")) {
    //   config.headers["Authorization"] = "Bearer " + sessionStorage.getItem("token");
    //   if (sessionStorage.getItem("userInfo")) {
    //     config.headers["sign-x"] = getNewKey();
    //   }
    // }
    if (config.apiType) {
      config.headers["Api-type"] = config.apiType;
    }
    // 版本号
    let headerVersion = base64.baseEncode("AGENT-" + "5.4.0");
    config.headers["version"] = headerVersion;

    if (!config.jsonHeader) {
      config.headers["Content-type"] = "application/json;charset=utf-8";
    } else {
      config.headers["Content-type"] = "application/x-www-form-urlencoded; charset=utf-8";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.config.apiType && response.config.apiType === "downFile") {
      return response.data;
    } else {
      const res = response.data;
      if (res.code !== 200) {
        if (res.code === 401 || res.code === 422) {
          ElMessageBox.alert('您尚未登录', '提示', {
            confirmButtonText: '前往登录',
            callback: () => {
              sessionStorage.clear();
              location.reload();
            },
          })
        } else if (res.code === 432) {
          ElMessage({
            message: res.msg,
            type: 'error',
          })
          setTimeout(() => {
            if (sessionStorage.getItem("token")) {
              sessionStorage.clear();
              location.reload();
            }
          }, 1500);
        } else {
          ElMessage({
            message: res.msg,
            type: 'error',
          })
        }
        // 返回 resolved 或者 rejected状态，供后续操作
        return Promise.reject(res);
      } else {
        return res;
      }
    }
  },
  async (error) => {
    if (error.request) {
      ElMessage({
        message: error.response.data.msg,
        type: 'error',
      })
    } else {
      ElMessage({
        message: error.response.data.msg,
        type: 'error',
      })
      sessionStorage.clear();
      // location.reload();
    }
    return Promise.reject(error);
  }
);

export default service;
